import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

// dialog component
@Component({
  selector: 'app-no-access-dialog',
  templateUrl: './no-access-dialog.component.html',
  styleUrls: ['./no-access-dialog.component.scss']
})
export class NoAccessDialogComponent implements OnInit {

  constructor(private router: Router, public dialogRef: MatDialogRef<NoAccessDialogComponent>) { }

  ngOnInit(): void { }

  // navigates to the open positions page
  home(event) {
    this.router.navigateByUrl('', { replaceUrl: true });
    this.dialogRef.close();
  }

  // navigates to the login page
  login(event) {
    this.router.navigateByUrl('careers/auth', { replaceUrl: true });
    this.dialogRef.close();
  }

}

// bottom sheet component
@Component({
  selector: 'app-no-access-bottom-sheet',
  templateUrl: './no-access-dialog.component.html',
  styleUrls: ['./no-access-dialog.component.scss']
})
export class NoAccessBottomSheetComponent implements OnInit {

  constructor(private router: Router, public bottomSheetRef: MatBottomSheetRef<NoAccessBottomSheetComponent>) { }

  ngOnInit(): void { }

  // navigates to the open positions page
  home(event) {
    this.router.navigateByUrl('', { replaceUrl: true });
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }

  // navigates to the login page
  login(event) {
    this.router.navigate(['careers/auth/'], { queryParams: { url: this.router.url }, replaceUrl: true });
    // this.router.navigateByUrl('careers/auth/login', { replaceUrl: true });
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }

}